import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import parsePhoneNumber from 'libphonenumber-js'

import { useModal, useSession, useSnackbar } from 'hooks'
import { useConfirm } from 'api/auth'

import FormPhoneNumber from '../components/FormPhoneNumber'
import ModalTemplate from '../components/ModalTemplate'
import FormCode from '../components/FormCode'
import useChangeMobileNumber from 'api/auth/useChangeMobileNumber'
import useSteps from 'hooks/useSteps'
import Congrats from '../components/Congrats'
import { ReactComponent as ErrorSVG } from 'assets/icons/snackbar/error.svg'


const Validate = () => {

  const { t } = useTranslation()
  const { Modal } = useModal()
  const { Modal: ModalWelcome } = useModal('welcome')
  const { Snackbar } = useSnackbar('error')

  const { logout, user, login, isPreLoggedIn } = useSession()

  const {
    changeMobileNumber,
    isLoading: isMobileLoading,
    isSuccess: isMobileSuccess,
    error: mobileError,
  } = useChangeMobileNumber()

  const {
    confirm,
    isLoading: isConfirmLoading,
    isSuccess: isConfirmSuccess,
    error: confirmError,
  } = useConfirm()

  const { step, nextStep, prevStep } = useSteps()

  const [country, setCountry] = useState()
  const [mobileNumber, setMobileNumber] = useState('')
  const [code, setCode] = useState('')


  const handleBackToWelcome = () => {
    ModalWelcome.open()
    logout()
  }

  const handleChangeMobile = ({ mobileNumber }) => changeMobileNumber({ mobileNumber })

  const handleConfirm = ({ code }) => {
    const { email } = user
    confirm({ email, code })
  }


  const errorInput = mobileError && mobileError?.code !== 412 && t('mobileNumberRegistered')

  const profileNumber = parsePhoneNumber(user.profile.mobileNumber)
  const countryCode = `+${profileNumber.countryCallingCode}`
  const mobileNumberFull = `${countryCode}${mobileNumber}`

  const newNumber = parsePhoneNumber(`${countryCode}${mobileNumber}`)
  const mobileNumberText = mobileNumber && newNumber?.formatInternational()

  useEffect(() => {
    setMobileNumber(profileNumber.nationalNumber)
  }, [])

  useEffect(() => {
    if (isMobileSuccess) nextStep()
  }, [isMobileSuccess])

  useEffect(() => {
    if (!mobileError) return
    
    if (mobileError.code === 412) {
      Snackbar.open({
        icon: ErrorSVG,
        message: t('operationLimitExceeded')
      })
    }
    
  }, [mobileError])

  useEffect(() => {
    if (isConfirmSuccess) {
      login()
      nextStep()
    }
  }, [isConfirmSuccess])



  if (step === 0) return (
    <ModalTemplate
      flowTitle={t('validateAccount')}
      currentStep={1}
      totalSteps={2}
      onBack={handleBackToWelcome}
      onClose={logout}
    >
      <FormPhoneNumber
        title={t('finishAccountValidation')}
        country={country}
        setCountry={setCountry}
        defaultCountryCode={countryCode}
        mobileNumber={mobileNumber}
        setMobileNumber={setMobileNumber}
        onSubmit={handleChangeMobile}
        isLoading={isMobileLoading}
        error={errorInput}
        showInfo
      />
    </ModalTemplate>
  )

  if (step === 1) return (
    <ModalTemplate
      flowTitle={t('validateAccount')}
      currentStep={2}
      totalSteps={2}
      onBack={prevStep}
      onClose={logout}
    >
      <FormCode
        title={t('enterCodeSentTo', {mobileNumber: mobileNumberText})}
        code={code}
        setCode={setCode}
        mobileNumber={mobileNumberFull}
        onSubmit={handleConfirm}
        isLoading={isConfirmLoading}
        error={confirmError && t('codeInvalid')}
        textCTA={isConfirmLoading
          ? t('validatingAccount')
          : t('validateAccount')
        }
      />
    </ModalTemplate>
  )

  if (step === 2) return (
    <Congrats
      title={t('congratsHaveCreatedAnAccount')}
      description={t('nowYouAreFlixxer')}
    />
  )
}

export default Validate